import {
  Alert,
  Avatar,
  Button,
  CardHeader,
  Chip,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CakeIcon from "@mui/icons-material/Cake";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";

import { useEffect, useState } from "react";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import { AssociationService } from "../../../service/AssociationService";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { blue } from "@mui/material/colors";
import { NA } from "../../../utils/utilities";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import AssociationInfo from "./AssociationInfo";
import { useNavigate } from "react-router-dom";
import { AddOutlined } from "@material-ui/icons";
import {
  showMoneyFormat,
  showNumbreFormat,
} from "../../../Helpers/utilsHelper";
import AssociationForm from "./AssociationForm";
import AppButton from "../shares/AppButton";

const MesAssociations = () => {
  const [expandedGrids, setExpandedGrids] = useState([]);
  const [mesAssociations, setMesAssociations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [associationFormOpen, setAssociationFormOpen] = useState(false);
  const [filtre, setFiltre] = useState({});
  const [selectedAssociation, setSelectedAssociation] = useState({});
  const navigate = useNavigate();
  const isMdUp = useMediaQuery("(min-width:960px)");

  const handleFetAssociationsList = (filtre) => {
    setLoading(true);
    AssociationService.getAllAssociation(filtre)
      .then((res) => {
        if (res && res.data) {
          setMesAssociations(res.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleShowInfo = (uuid) => {
    navigate(`/mes-associations/info?uuid=${uuid}`);
  };

  const handleAssociationFormClose = () => {
    setAssociationFormOpen(false);
  };
  const handleAssociationFormOpen = () => {
    setAssociationFormOpen(true);
  };

  useEffect(() => {
    handleFetAssociationsList(filtre);
  }, [filtre]);

  return (
    <>
      <AssociationForm
        idAssociation={null}
        onFormClose={handleAssociationFormClose}
        open={associationFormOpen}
      />
      <Grid container display={"flex"} flexDirection={"row"} mr={2}>
        <Grid item xs={12}>
          <Grid container p={3}>
            <TextField
              id="reacherche"
              fullWidth
              size="small"
              placeholder="Recherche"
              InputProps={{
                endAdornment: (
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                ),
              }}
            />
          </Grid>
          <CardHeader
            title="Liste de mes associations"
            action={
              <Button
                size="small"
                variant={isMdUp ? "outlined" : "text"}
                title="Créer nouvelle sur l'association"
                startIcon={<AddOutlined style={{ fontSize: "25px" }} />}
                sx={{ borderRadius: "0" }}
                onClick={(e) => handleAssociationFormOpen()}
              >
                <Typography
                  variant="body2"
                  sx={{ display: { xs: "none", md: "block" } }}
                >
                  Creer
                </Typography>
              </Button>
            }
          />
          {mesAssociations.length === 0 && (
            <Grid container justifyContent={"center"}>
              <Grid item xs={10}>
                <Alert severity="info">Aucune association trouvée</Alert>
              </Grid>
            </Grid>
          )}
          {mesAssociations.map((item, index) => (
            <Paper elevation={0} key={index}>
              <Grid item xs={12} m={1} key={`k-${index}`} minHeight={100}>
                <Grid>
                  <CardHeader
                    title={
                      <Grid>
                        {`${item.nom} `}{" "}
                        <Chip
                          label={`${showNumbreFormat(item.nb_membre, "membre")}`}
                          color="primary"
                          size="small"
                          variant="outlined"
                        />
                      </Grid>
                    }
                    titleTypographyProps={{ variant: "h5" }}
                    subheader={
                      <Grid>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <CakeIcon />
                          <span>{`Crée en ${item.annee_creation}`}</span>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <LocationOnOutlinedIcon />
                          <span>{`${item.adresse || NA()}`}</span>
                        </Stack>
                      </Grid>
                    }
                    subheaderTypographyProps={{ variant: "caption" }}
                    avatar={
                      <Avatar
                        sx={{
                          bgcolor: blue[900],
                          height: "75px",
                          width: "75px",
                        }}
                        variant="rounded"
                      >
                        <PeopleAltOutlinedIcon />
                      </Avatar>
                    }
                    action={
                      <Grid spacing={3} display={"flex"}>
                        {/* <Grid>
                        <Button color="secondary" variant={isMdUp ? "outlined" : "text"} title="Modifier association" startIcon={<EditOutlined />}>
                          <Typography variant="body2"  sx={{display: {xs: "none", md: "block" }}} >Modif</Typography>
                        </Button>
                      </Grid> */}
                        <Grid ml={1}>
                          <Button
                            variant={isMdUp ? "outlined" : "text"}
                            title="Info sur l'association"
                            startIcon={<InfoOutlinedIcon />}
                            onClick={(e) => handleShowInfo(item.uuid)}
                            sx={{ borderRadius: "0" }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ display: { xs: "none", md: "block" } }}
                            >
                              Info
                            </Typography>
                          </Button>
                        </Grid>
                      </Grid>
                    }
                  />
                </Grid>
                <Grid>
                  <AppButton />
                </Grid>
              </Grid>
              <Divider variant="middle" flexItem sx={{ m: 1 }} />
            </Paper>
          ))}
        </Grid>
      </Grid>
    </>
  );
};

export default MesAssociations;
